import * as React from "react";

interface ILiveChatState {
  hasInitialised: boolean;
  bcLoadAvailable: boolean; // has the function to load the bold script been added to the window
}

interface ILiveChatProps {
  customerCode?: string;
  liveChat?: Window["oetal"]["pageData"]["liveChat"];
}

export const isLiveChatAvailable = (_window: Window) =>
  !!(_window && typeof _window._bcLoad === "function");

export const shouldEnableLiveChat = (customerCode, liveChat) => {
  if (!liveChat || !liveChat.enabled) {
    return false;
  }

  if (!customerCode || customerCode === "SME") {
    return false;
  }

  return true;
};

const CHAT_WINDOW_ID = "bc-chat-container";
export class LiveChat extends React.Component<ILiveChatProps, ILiveChatState> {
  private _bcWindow: MutationObserver | null = null;
  private chatWindowLoaded: boolean = false;

  constructor(props) {
    super(props);
    this.state = {
      hasInitialised: false,
      bcLoadAvailable: false
    };
  }

  componentDidMount() {
    const _window: Window = (global as any).window || {};
    if (!isLiveChatAvailable(_window)) {
      window.addEventListener("bcLoadAvailable", this.setBoldAvailable);
    }

    this._bcWindow = new MutationObserver(() => {
      const bcChatWindow = document.getElementById(CHAT_WINDOW_ID);
      if (bcChatWindow && !this.chatWindowLoaded) {
        if (window.newrelic) {
          this.chatWindowLoaded = true;
          _window.newrelic.addPageAction("liveChat");
        }
      } else if (!bcChatWindow && this.chatWindowLoaded) {
        this.chatWindowLoaded = false;
      }
    });

    this._bcWindow.observe(document.body, { childList: true, subtree: false });
  }

  componentWillUnmount() {
    window.removeEventListener("bcLoadAvailable", this.setBoldAvailable);
    this._bcWindow && this._bcWindow.disconnect();
  }

  setBoldAvailable = () => {
    this.setState({ bcLoadAvailable: true });
  };

  static getDerivedStateFromProps = (
    { customerCode, liveChat },
    { hasInitialised }
  ) => {
    const _window: Window = (global as any).window || {};

    if (hasInitialised) {
      return null;
    }

    if (
      isLiveChatAvailable(_window) &&
      shouldEnableLiveChat(customerCode, liveChat)
    ) {
      _window._bcLoad();

      return {
        hasInitialised: true
      };
    }

    return null;
  };

  render() {
    return null;
  }
}
